<!-- 车皮调度计划 -->
<template>
  <div class="nx-list-page">
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @search-change="searchChange" :before-open="beforeOpen" @search-reset="searchReset" @refresh-change="refreshChange" @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad">
      <template slot="menuLeft">
        <el-button type="primary" size="small" plain icon="el-icon-upload2" @click="handleImport">导入</el-button>
        <el-button type="primary" size="small" plain icon="el-icon-download" :loading="templateLoading" @click="handleDownloadImportTemplate">导入模版下载</el-button>
        <el-button type="primary" size="small" plain icon="el-icon-download" :loading="exportLoading" @click="handleExport">导出</el-button>
      </template>
      <template slot-scope="{row, index}" slot="menu">
        <el-button v-if="canShowAudit(row)" type="text" size="small" :loading="auditLoadingId === row.id" @click="handleAudit(row)">审核</el-button>
        <el-button v-if="canShowAudit(row)" type="text" size="small" :loading="auditLoadingId === row.id" @click="handleAuditReject(row)">驳回</el-button>
        <el-button v-if="canShowUnAudit(row)" type="text" size="small" :loading="auditLoadingId === row.id" @click="handleUnAudit(row)">取消审核</el-button>
        <el-button v-if="canDownloadTicket(row)" type="text" size="small" @click="handleDownloadTicket(row)">作业票下载</el-button>
        <el-button v-if="canShowSendArrival(row)" type="text" size="small" :loading="sendLoadingId === row.id" :disabled="isSendArrivalDisabled(row)" @click="handleSendRailwayArrival(row)">发送到达通知</el-button>
        <el-button v-if="canShowRollbackArrival(row)" type="text" size="small" :loading="rollbackLoadingId === row.id" @click="handleRollbackRailwayArrival(row)">回滚到达通知</el-button>
        <el-button v-if="canEditDispatch(row)" type="text" size="small" @click="$refs.crud.rowEdit(row, index)">编辑</el-button>
        <el-button v-if="canEditDispatch(row)" type="text" size="small" @click="$refs.crud.rowDel(row, index)">删除</el-button>
      </template>
    </avue-crud>
    <dialog-reset height="75vh" top="5vh" width="80%" :title="formTitle" :visible.sync="formVisible">
      <form-component ref="formComponen" :transmitData="transmitData" @handleClose="handleClose"></form-component>
    </dialog-reset>
  </div>
</template>
<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, remove, importExcel, exportExcel, downloadImportTemplate, sendRailwayArrival, rollbackRailwayArrival, getRailwayArrivalSendLock, audit, auditReject, unAudit } from "./api";
import { searchTimeConfig, transitionTitle } from "@/basic-common/util/common";
import { downloadXls } from '@/util/util'
import FormComponent from './components/form-component.vue'

const padTime = value => {
  const text = String(value)
  return text.length < 2 ? `0${text}` : text
}
const formatDateTime = date => {
  const year = date.getFullYear()
  const month = padTime(date.getMonth() + 1)
  const day = padTime(date.getDate())
  const hour = padTime(date.getHours())
  const minute = padTime(date.getMinutes())
  const second = padTime(date.getSeconds())
  return `${year}-${month}-${day} ${hour}:${minute}:${second}`
}
const getDefaultSearchDateRange = () => {
  const start = new Date()
  start.setDate(start.getDate() - 7)
  start.setHours(0, 0, 0, 0)
  const end = new Date()
  end.setDate(end.getDate() + 7)
  end.setHours(23, 59, 59, 999)
  return [formatDateTime(start), formatDateTime(end)]
}

export default {
  mixins: [crudMixins],
  components: { FormComponent },
  data () {
    const defaultSearchDateRange = getDefaultSearchDateRange()
    return {
      apiConfig: { getList, remove },
      exportLoading: false,
      templateLoading: false,
      sendLoadingId: null,
      rollbackLoadingId: null,
      auditLoadingId: null,
      sendLock: {
        locked: false,
        arrivalNoticeId: null,
      },
      defaultParams: {
        startTime: defaultSearchDateRange[0],
        endTime: defaultSearchDateRange[1],
      },
      formVisible: false,
      option: {
        ...this.$store.state.publicOption,
        addBtn: true,
        editBtn: false,
        viewBtn: true,
        delBtn: false,
        column: [
          {
            label: '计划号',
            prop: 'planNo',
            overHidden: true,
            width: 150,
          },
          {
            label: '车次编号',
            prop: 'trainNumber',
            search: true,
            overHidden: true,
            width: 150,
            maxlength: 30,
            showWordLimit: true,
          },
          {
            label: '客户',
            prop: 'custNo',
            overHidden: true,
            search: true,
            type: 'select',
            remote: true,
            dicUrl: '/api/produce/blade-dept/select/distinct/select',
            props: {
              label: 'deptName',
              value: 'id'
            },
            width: 150,
          },
          {
            label: '物资名称',
            prop: 'cargoName',
            type: 'select',
            remote: true,
            dicUrl: '/api/produce/vardict/select/distinct/pycode?varName={{key}}',
            props: {
              label: 'varName',
              value: 'id'
            },
            width: 120,
          },
          {
            label: '到达点',
            prop: 'cargoFlow',
            overHidden: true,
            width: 110,
            formatter: (row) => this.formatCargoFlow(row.cargoFlow),
          },
          {
            label: '到达作业方式',
            prop: 'arrivalOperationMode',
            overHidden: true,
            width: 130,
            formatter: (row) => this.formatArrivalOperationMode(row.arrivalOperationMode),
          },
          {
            label: '库位',
            prop: 'locationName',
            overHidden: true,
            width: 180,
            formatter: (row) => this.formatLocation(row),
          },
          {
            label: '车厢数',
            prop: 'carriageCount',
            search: true,
            overHidden: true,
            width: 100,
            type: 'number',
            min: 1,
            max: 99999,
          },
          {
            label: '计划量(吨)',
            prop: 'totalWeight',
            overHidden: true,
            width: 100,
            type: 'number',
            precision: 2,
            min: 0.01,
            max: 99999,
          },
          {
            label: '计划状态',
            prop: 'planState',
            overHidden: true,
            width: 110,
            formatter: (row) => this.formatPlanState(row.planState),
          },
          {
            label: '执行量(吨)',
            prop: 'planExecuteWeight',
            overHidden: true,
            width: 110,
            formatter: (row) => this.formatWeight(row.planExecuteWeight),
          },
          {
            label: '偏差值(吨)',
            prop: 'deviationWeight',
            overHidden: true,
            width: 120,
            formatter: (row) => this.formatDeviationWeight(row),
          },
          {
            label: '预计到达时间',
            prop: 'trainArrivalTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true,
            width: 180,
          },
          {
            label: '是否到达',
            prop: 'arrivalStatus',
            search: true,
            overHidden: true,
            type: 'select',
            dataType: 'string',
            dicData: this.$store.getters.commonDict['arrival_status'],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '发送状态',
            prop: 'noticeSendStatus',
            overHidden: true,
            type: 'select',
            width: 120,
            dicData: [
              { label: '未发送', value: 0 },
              { label: '待匹配', value: 1 },
              { label: '已匹配', value: 2 },
            ],
          },
          {
            label: '审核状态',
            prop: 'auditFlag',
            search: true,
            overHidden: true,
            type: 'select',
            dataType: 'string',
            width: 110,
            dicUrl: '/api/blade-system/dict-biz/dictionary?code=audit_flag',
            props: {
              label: 'dictValue',
              value: 'dictKey'
            },
            formatter: (row) => this.formatAuditFlag(row.auditFlag),
          },
          {
            label: '审核时间',
            prop: 'auditTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true,
            width: 180,
          },
          {
            label: '审核备注',
            prop: 'auditRemark',
            overHidden: true,
            width: 160,
          },
          {
            label: '发送时间',
            prop: 'noticeSendTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true,
            width: 180,
          },
          {
            label: '合同名称',
            prop: 'contractName',
            overHidden: true,
            width: 150,
            type: 'select',
            props: {
              label: 'contractName',
              value: 'id'
            },
          },
          {
            ...searchTimeConfig,
            pickerOptions: {
              shortcuts: searchTimeConfig.pickerOptions.shortcuts,
            },
            paramsKey: ["startTime", "endTime"],
            searchValue: defaultSearchDateRange,
          },
        ]
      },
    }
  },
  methods: {
    /** 是否到达：与字典 arrival_status 中「已到达」一致，一般为 1 */
    isArrived (row) {
      if (!row) return false
      const s = row.arrivalStatus
      return s === 1 || s === '1'
    },
    isCustomerSubmit (row) {
      return row && (row.submitSource === 2 || row.submitSource === '2')
    },
    isPlanRow (row) {
      return row && row.transportPlanId && String(row.transportPlanId) === String(row.id) && !row.arrivalNo
    },
    isAuditPassed (row) {
      return row && (row.auditFlag === 2 || row.auditFlag === '2')
    },
    isAuditPending (row) {
      if (!this.isCustomerSubmit(row)) return false
      return row.auditFlag === undefined || row.auditFlag === null || row.auditFlag === 0 || row.auditFlag === '0'
    },
    formatAuditFlag (value) {
      if (value === undefined || value === null || value === '') return '历史数据'
      const map = { 0: '待审核', 2: '已审核', 3: '已驳回' }
      return map[value] || map[String(value)] || value
    },
    formatPlanState (value) {
      if (value === undefined || value === null || value === '') return '未开始'
      const map = { 0: '未开始', 1: '进行中', 2: '已完成' }
      return map[value] || map[String(value)] || value
    },
    formatCargoFlow (value) {
      const map = { 1: '铁运入库', 2: '铁运至电厂' }
      return map[value] || map[String(value)] || ''
    },
    formatArrivalOperationMode (value) {
      const normalized = value === undefined || value === null || value === '' ? 1 : value
      const map = { 1: '翻车机卸车', 2: '汽运短倒' }
      return map[normalized] || map[String(normalized)] || ''
    },
    formatYesNo (value) {
      return String(value || 0) === '1' ? '是' : '否'
    },
    formatLocation (row = {}) {
      const stock = row.stockName || row.stockCode || ''
      const location = row.locationName || row.locationCode || ''
      return [stock, location].filter(Boolean).join(' / ')
    },
    formatWeight (value) {
      const n = Number(value || 0)
      if (!Number.isFinite(n)) return '0.00'
      return n.toFixed(2)
    },
    isPlanCompleted (row = {}) {
      return row.planState === 2 || row.planState === '2'
    },
    formatDeviationWeight (row = {}) {
      if (!this.isPlanCompleted(row)) {
        return ''
      }
      if (row.deviationWeight !== undefined && row.deviationWeight !== null && row.deviationWeight !== '') {
        return this.formatWeight(row.deviationWeight)
      }
      const totalWeight = Number(row.totalWeight || 0)
      const executeWeight = Number(row.planExecuteWeight || 0)
      return this.formatWeight(totalWeight - executeWeight)
    },
    canShowAudit (row) {
      return this.hasActionPermission('arrivalnoteplan_audit') && this.isAuditPending(row) && !this.isArrived(row)
    },
    canShowUnAudit (row) {
      return this.hasActionPermission('arrivalnoteplan_audit') && this.isCustomerSubmit(row) && this.isAuditPassed(row) && !this.isArrived(row) && (row.noticeSendStatus === 0 || row.noticeSendStatus === '0' || row.noticeSendStatus === undefined || row.noticeSendStatus === null)
    },
    canDownloadTicket (row) {
      return row && row.railwayOperationTicketUrl && this.hasActionPermission('arrivalnoteplan_ticket_download')
    },
    canEditDispatch (row) {
      return !this.isArrived(row) && !this.isPlanRow(row) && !this.isCustomerSubmit(row)
    },
    hasActionPermission (code) {
      return !this.permission || this.permission[code] !== false
    },
    canShowSendArrival (row) {
      if (!row) return false
      if (this.isPlanRow(row)) return false
      if (this.isCustomerSubmit(row) && !this.isAuditPassed(row)) return false
      const status = row.noticeSendStatus
      return !this.isArrived(row) && status !== 2 && status !== '2'
    },
    canShowRollbackArrival (row) {
      if (!row || !row.id) return false
      if (this.isPlanRow(row)) return false
      const status = row.noticeSendStatus
      const matchId = row.noticeMatchRecordId
      return (status === 1 || status === '1') && (matchId === undefined || matchId === null || matchId === '' || matchId === 0 || matchId === '0')
    },
    isSendArrivalDisabled (row) {
      if (!row || this.sendLoadingId) return true
      const status = row.noticeSendStatus
      if (status === 1 || status === '1') return true
      return false
    },
    async handleSendRailwayArrival (row) {
      if (!row || !row.id) return
      this.sendLoadingId = row.id
      try {
        const res = await sendRailwayArrival(row.id)
        const data = (res && res.data && res.data.data) || (res && res.data) || {}
        this.$message.success(data.message || '发送成功')
        this.onLoad(this.page, this.query)
      } catch (e) {
        this.$message.error((e && e.message) || '发送失败')
      } finally {
        this.sendLoadingId = null
      }
    },
    async handleRollbackRailwayArrival (row) {
      if (!row || !row.id) return
      try {
        await this.$confirm('确认回滚到达通知？回滚后该记录将回到未发送状态。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        this.rollbackLoadingId = row.id
        const res = await rollbackRailwayArrival(row.id)
        const data = (res && res.data && res.data.data) || (res && res.data) || {}
        this.$message.success(data.message || '回滚成功')
        this.onLoad(this.page, this.query)
      } catch (e) {
        if (e !== 'cancel' && e !== 'close') {
          this.$message.error((e && e.message) || '回滚失败')
        }
      } finally {
        this.rollbackLoadingId = null
      }
    },
    async handleAudit (row) {
      if (!row || !row.id) return
      try {
        await this.$confirm_primary('审核')
        this.auditLoadingId = row.id
        await audit(row.transportPlanId || row.id)
        this.$message.success('操作成功')
        await this.refreshSendLock()
        this.onLoad(this.page, this.query)
      } finally {
        this.auditLoadingId = null
      }
    },
    async handleAuditReject (row) {
      if (!row || !row.id) return
      try {
        const { value } = await this.$prompt('请输入驳回原因', '驳回', {
          confirmButtonText: '确认驳回',
          cancelButtonText: '取消',
          inputType: 'textarea',
          inputPlaceholder: '请输入驳回原因',
          inputValidator: value => !!(value && value.trim()) || '驳回原因不能为空',
        })
        this.auditLoadingId = row.id
        await auditReject({ id: row.transportPlanId || row.id, auditRemark: value })
        this.$message.success('已驳回')
        this.onLoad(this.page, this.query)
      } finally {
        this.auditLoadingId = null
      }
    },
    async handleUnAudit (row) {
      if (!row || !row.id) return
      try {
        await this.$confirm_primary('取消审核')
        this.auditLoadingId = row.id
        await unAudit(row.transportPlanId || row.id)
        this.$message.success('操作成功')
        await this.refreshSendLock()
        this.onLoad(this.page, this.query)
      } finally {
        this.auditLoadingId = null
      }
    },
    handleDownloadTicket (row) {
      const url = row && row.railwayOperationTicketUrl
      if (!url) {
        this.$message.warning('作业票文件不存在')
        return
      }
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      link.download = row.railwayOperationTicketOriginalName || row.railwayOperationTicketName || '铁路作业票.pdf'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    hasValidSearchDate (searchDate) {
      return Array.isArray(searchDate) && searchDate.length === 2 && searchDate[0] && searchDate[1]
    },
    syncDefaultSearchTime (searchDate) {
      this.defaultParams = {
        ...this.defaultParams,
        startTime: searchDate[0],
        endTime: searchDate[1],
      }
    },
    clearDefaultSearchTime () {
      const defaultParams = { ...this.defaultParams }
      delete defaultParams.startTime
      delete defaultParams.endTime
      this.defaultParams = defaultParams
    },
    normalizeSearchParams (params = {}) {
      const queryParams = { ...params }
      const searchDate = queryParams.searchDate
      if (this.hasValidSearchDate(searchDate)) {
        queryParams.searchDate = searchDate
        this.syncDefaultSearchTime(searchDate)
        return queryParams
      }
      delete queryParams.searchDate
      delete queryParams.startTime
      delete queryParams.endTime
      this.clearDefaultSearchTime()
      return queryParams
    },
    searchChange (params, done) {
      const queryParams = this.normalizeSearchParams(params)
      this.query = queryParams
      this.page.currentPage = 1
      this.selectionClear()
      this.onLoad(this.page, queryParams)
      if (done) done()
    },
    searchReset () {
      const defaultSearchDateRange = getDefaultSearchDateRange()
      this.defaultParams = {
        ...this.defaultParams,
        startTime: defaultSearchDateRange[0],
        endTime: defaultSearchDateRange[1],
      }
      this.query = {
        searchDate: defaultSearchDateRange,
      }
      this.selectionClear()
      this.onLoad(this.page, this.query)
    },
    // 新增
    handleAdd () {
      this.$refs.info.open('新增')
    },
    // 查看详情
    getInfo (row) {
      this.$refs.info.open('查看详情', row)
    },
    //修改
    handleUpdate (row) {
      this.$refs.info.open('修改', row)
    },
    beforeOpen (done, type) {
      // 1.传递交互参数 type id  操作api
      this.transmitData = {
        type,
        id: this.form.id || null,
      }
      this.formTitle = transitionTitle(type)
      this.formVisible = true
    },
    handleClose (type) {
      this.formVisible = false
      // 保存并关闭后刷新列表
      if (type) {
        this.onLoad(this.page, this.query)
      }
    },
    async handleImport () {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.xlsx,.xls'
      input.onchange = async (e) => {
        const file = e.target.files[0]
        if (!file) return
        const fileName = file.name || ''
        const lowerName = fileName.toLowerCase()
        if (!lowerName.endsWith('.xls') && !lowerName.endsWith('.xlsx')) {
          this.$message.error('仅支持上传 xls、xlsx 格式文件')
          return
        }
        try {
          await importExcel(file)
          this.$message.success('导入成功')
          this.onLoad(this.page, this.query)
        } catch (error) {
          this.$message.error('导入失败：' + (error.message || '未知错误'))
        }
      }
      input.click()
    },
    async handleDownloadImportTemplate () {
      this.templateLoading = true
      try {
        const res = await downloadImportTemplate()
        downloadXls(res.data, '列车计划模板.xlsx')
        this.$message.success('模版下载成功')
      } catch (e) {
        this.$message.error((e && e.message) || '模版下载失败')
      } finally {
        this.templateLoading = false
      }
    },
    async handleExport () {
      if ((this.page.total || 0) < 1) {
        this.$message.warning('无数据可导出')
        return
      }
      this.exportLoading = true
      try {
        const queryParams = this.normalizeSearchParams(this.query)
        const params = this.formatParams(Object.assign({}, this.defaultParams, queryParams))
        const res = await exportExcel(params)
        downloadXls(res.data, `车皮调度计划_${Date.now()}.xlsx`)
        if (this.page.total > 10000) {
          this.$message.warning(`仅导出前 10000 条，共 ${this.page.total} 条`)
        } else {
          this.$message.success('导出成功')
        }
      } catch (e) {
        this.$message.error('导出失败')
      } finally {
        this.exportLoading = false
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
